import { Col, notification, Row } from 'antd';
import React, { useEffect, useState } from 'react';
import { useHistory, useLocation, useParams } from 'react-router-dom';
import { useDebouncedCallback } from 'use-debounce';

import AlertAviso from '../../../components/AlertAviso';
import { useContatosContext } from '../../../contexts/ContatosContexto';
import { showErrors } from '../../../helpers/form';
import {
  customUpperCase,
  formatarCnpjCpfIMask,
} from '../../../helpers/formatador';
import geradorIdUnico from '../../../helpers/geradores';
import { gTagEntrada, gTagSaida } from '../../../helpers/googleAnalytics';
import { useAuth } from '../../../security/authContext';
import apiNetCore from '../../../services/apiNetCore';
import Contatos from './Steps/Contatos';
import DadosGerais from './Steps/DadosGerais';
import Demanda from './Steps/Demanda';
import Expedidor from './Steps/Expedidor';
import Recebedor from './Steps/Recebedor';
import Resumo from './Steps/Resumo';
import {
  Button,
  Footer,
  Form,
  GlobalStyle,
  SpinAllSize,
  StepContent,
  Steps,
  VoltarButton,
} from './styles';

const { Step } = Steps;

const CadastroDemanda = () => {
  const { user } = useAuth();
  const location = useLocation();
  const { idDemanda } = useParams();
  const [form] = Form.useForm();
  const history = useHistory();
  const [currentStep, setCurrentStep] = useState(0);
  const [loading, setLoading] = useState(false);
  const [clienteEnderecoRemetente, setClienteEnderecoRemetente] = useState([]);
  const [
    clienteEnderecoDestinatario,
    setClienteEnderecoDestinatario,
  ] = useState([]);
  const [clienteExpedidor, setClienteExpedidor] = useState([]);
  const [clienteRecebedor, setClienteRecebedor] = useState([]);
  const [disableNext, setDisableNext] = useState(true);
  const [demanda, setDemanda] = useState({});
  const [dadosPagador, setDadosPagador] = useState({});
  const [lotes, setLotes] = useState([]);
  const [editingDemanda, setEditingDemanda] = useState(false);
  const [hasContrato, setHasContrato] = useState(false);
  const [hasMotorista, setHasMotorista] = useState(false);
  const [isExpedidorIgualRemetente, setIsExpedidorIgualRemetente] = useState(
    false
  );
  const [
    isRecebedorIgualDestinatario,
    setIsRecebedorIgualDestinatario,
  ] = useState(false);
  const [alertMessageErrors, setAlertMessageErrors] = useState([]);
  const [eventId, setEventId] = useState('');
  const tabsFields = [['cnpjPagador', 'produto', 'especie'], []];
  const {
    setContatosAction,
    contatos,
    clearContatosAction,
  } = useContatosContext();

  const steps = [
    {
      title: 'Dados gerais',
      content: (
        <DadosGerais
          demanda={demanda}
          setDemanda={setDemanda}
          form={form}
          clienteEnderecoRemetente={clienteEnderecoRemetente}
          setClienteEnderecoRemetente={setClienteEnderecoRemetente}
          clienteEnderecoDestinatario={clienteEnderecoDestinatario}
          setClienteEnderecoDestinatario={setClienteEnderecoDestinatario}
          dadosPagador={dadosPagador}
          setDadosPagador={setDadosPagador}
          hasContrato={hasContrato}
          hasMotorista={hasMotorista}
          setAlertMessageErrors={setAlertMessageErrors}
          editingDemanda={editingDemanda}
          setEditingDemanda={setEditingDemanda}
          clienteExpedidor={clienteExpedidor}
        />
      ),
    },
    {
      title: 'Expedidor',
      content: (
        <Expedidor
          form={form}
          clienteExpedidor={clienteExpedidor}
          setClienteExpedidor={setClienteExpedidor}
          clienteEnderecoRemetente={clienteEnderecoRemetente}
          hasContrato={hasContrato}
          isExpedidorIgualRemetente={isExpedidorIgualRemetente}
          setIsExpedidorIgualRemetente={setIsExpedidorIgualRemetente}
          setAlertMessageErrors={setAlertMessageErrors}
          dadosPagador={dadosPagador}
        />
      ),
    },
    {
      title: 'Recebedor',
      content: (
        <Recebedor
          form={form}
          clienteRecebedor={clienteRecebedor}
          setClienteRecebedor={setClienteRecebedor}
          clienteEnderecoDestinatario={clienteEnderecoDestinatario}
          hasContrato={hasContrato}
          isRecebedorIgualDestinatario={isRecebedorIgualDestinatario}
          setIsRecebedorIgualDestinatario={setIsRecebedorIgualDestinatario}
          setAlertMessageErrors={setAlertMessageErrors}
        />
      ),
    },
    {
      title: 'Contatos',
      content: <Contatos form={form} />,
    },
    {
      title: 'Direcionamentos',
      content: (
        <Demanda
          demanda={demanda}
          setDemanda={setDemanda}
          lotes={lotes}
          setLotes={setLotes}
          dadosPagador={dadosPagador}
          clienteEnderecoRemetente={clienteEnderecoRemetente}
          clienteEnderecoDestinatario={clienteEnderecoDestinatario}
          clienteExpedidor={clienteExpedidor}
          clienteRecebedor={clienteRecebedor}
          setAlertMessageErrors={setAlertMessageErrors}
          editingDemanda={editingDemanda}
          idDemanda={idDemanda}
          hasMotorista={hasMotorista}
        />
      ),
    },
    {
      title: 'Resumo',
      content: (
        <Resumo
          form={form}
          lotes={lotes}
          demanda={demanda}
          clienteEnderecoRemetente={clienteEnderecoRemetente}
          clienteEnderecoDestinatario={clienteEnderecoDestinatario}
          clienteExpedidor={clienteExpedidor}
          clienteRecebedor={clienteRecebedor}
        />
      ),
    },
  ];

  const validFormStepDadosGerais = () => {
    const fieldsValue = form.getFieldsValue(tabsFields[currentStep]);

    if (
      Object.values(fieldsValue).filter(value => !value).length !== 0 ||
      clienteEnderecoRemetente.length === 0 ||
      clienteEnderecoDestinatario.length === 0 ||
      alertMessageErrors.find(item => item.required) > 0
    ) {
      return true;
    }

    demanda.idEspecie = fieldsValue.especie;
    demanda.idProduto = fieldsValue.produto;
    demanda.observacao = form.getFieldValue('observacoes');
    demanda.numPedidoCliente = form.getFieldValue('numPedidoCliente');

    setDemanda(demanda);
  };

  const validFormStepExpedidor = () => clienteExpedidor.length === 0;

  const validFormStepRecebedor = () => clienteRecebedor.length === 0;

  const validateForm = async () => {
    let disable = true;
    switch (currentStep) {
      case 0:
        disable = validFormStepDadosGerais();
        break;
      case 1:
        disable = validFormStepExpedidor();
        break;
      case 2:
        disable = validFormStepRecebedor();
        break;
      default:
        disable = false;
        break;
    }

    setDisableNext(disable);
    return disable;
  };

  const previousStep = () => {
    if (currentStep === 0) return history.push('/demandas');
    setCurrentStep(currentStep - 1);
    gTagEntrada(
      `Passo - ${steps[currentStep - 1].title}`,
      'Demanda',
      `Voltou ao passo - ${steps[currentStep - 1].title}`,
      eventId || location.state.eventId
    );
  };

  const nextStep = () => {
    setCurrentStep(currentStep + 1);
    gTagEntrada(
      `Passo - ${steps[currentStep + 1].title}`,
      'Demanda',
      `Entrou passo ${steps[currentStep + 1].title}`,
      eventId || location.state.eventId
    );
  };

  const validateFormDebounced = useDebouncedCallback(validateForm, 300);

  useEffect(() => {
    validateFormDebounced();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    currentStep,
    clienteEnderecoRemetente,
    clienteEnderecoDestinatario,
    clienteExpedidor,
    clienteRecebedor,
  ]);

  const redirectCriacaoEdicaoDemanda = id_demanda => {
    if (id_demanda) history.push(`/detalhesDemanda/${id_demanda}`);
    else history.push('/demandas');
  };

  const showSubmitDemandaNotification = () => {
    notification.success({
      message: 'Tudo certo',
      description: editingDemanda
        ? 'A demanda foi atualizada com sucesso.'
        : 'A demanda foi cadastrada com sucesso.',
    });
  };

  const handleSubmit = async () => {
    setLoading(true);

    try {
      const data = {
        idClienteShipper: demanda.idClienteShipper,
        idUsuarioShipper: user.id,
        idUsuarioIntegracao: user.id_usuario_integracao,
        idClientePagador: demanda.idClientePagador,
        idEspecie: demanda.idEspecie,
        idProduto: demanda.idProduto,
        observacao: demanda.observacao,
        numPedidoCliente: demanda.numPedidoCliente,
        volumeTotal: demanda.volumeTotal,
        cadenciaDiariaTotal: demanda.cadenciaDiariaTotal,
        livreConcorrencia: demanda.livreConcorrencia,
        tipoPagamento: demanda.tipoPagamento,

        clienteEnderecoRemetente: clienteEnderecoRemetente.map(
          clienteRemetente => ({
            idCliente: clienteRemetente.idCliente,
            idClienteEndereco: clienteRemetente.idClienteEndereco,
            idCidade: clienteRemetente.idCidade,
          })
        ),

        clienteEnderecoDestinatario: clienteEnderecoDestinatario.map(
          clienteDestinatario => ({
            idCliente: clienteDestinatario.idCliente,
            idClienteEndereco: clienteDestinatario.idClienteEndereco,
            idCidade: clienteDestinatario.idCidade,
          })
        ),

        clienteEnderecoExpedidor: clienteExpedidor.map(clienteE => ({
          idCliente: clienteE.idCliente,
          idClienteEndereco: clienteE.idClienteEndereco,
          idCidade: clienteE.idCidade,
        })),

        clienteEnderecoRecebedor: clienteRecebedor.map(clienteR => ({
          idCliente: clienteR.idCliente,
          idClienteEndereco: clienteR.idClienteEndereco,
          idCidade: clienteR.idCidade,
        })),
        lotes,
        contatos: contatos || null,
        demandaHorariosEmbarque: demanda.demandaHorariosEmbarque,
        periodoCarregamento: demanda.periodoCarregamento,
      };

      if (editingDemanda) {
        const res = await apiNetCore.put(`/demanda/${idDemanda}`, data);

        if (res.status === 200) {
          gTagSaida(
            'Submit - Demanda Editada',
            'Demanda',
            `Demanda ${idDemanda} foi editada`,
            eventId
          );
        }

        showSubmitDemandaNotification();

        redirectCriacaoEdicaoDemanda(idDemanda);
      } else {
        const { data: idDemandaRetornado, status } = await apiNetCore.post(
          '/demanda',
          data
        );

        if (status === 200) {
          gTagSaida(
            'Submit - Demanda Criada',
            'Demanda',
            'Nova demanda foi criada',
            location.state.eventId
          );
        }

        showSubmitDemandaNotification();

        redirectCriacaoEdicaoDemanda(idDemandaRetornado);
      }

      setLoading(false);
    } catch (error) {
      const errors = error?.response?.data?.message
        ? Object.values(error?.response?.data?.message)
        : null;
      showErrors(errors);
    } finally {
      setLoading(false);
    }
  };

  const redirecionaStep = useDebouncedCallback(step => {
    setCurrentStep(step);
    setLoading(false);
  }, 1000);

  const validateEventId = () => {
    if (process.env.NODE_ENV === 'development') return geradorIdUnico();
    return location.state.eventId;
  };

  useEffect(() => {
    async function onInit() {
      if (!idDemanda) {
        clearContatosAction();
        gTagEntrada(
          `Passo - ${steps[currentStep].title}`,
          'Demanda',
          `Estrou no ${steps[currentStep].title}`,
          validateEventId()
        );
        return;
      }
      setEditingDemanda(true);
      setLoading(true);
      try {
        const { data } = await apiNetCore.get(`/demanda/${idDemanda}`);

        if (!data) return history.push('/demandas');

        const clientePagadorAsOrigem = data.enderecoOrigem.find(
          cliente => cliente.idCliente === data.idClientePagador
        );

        const clientePagadorAsDestino = data.enderecoDestino.find(
          cliente => cliente.idCliente === data.idClientePagador
        );

        let clientePagadorFront;
        if (clientePagadorAsOrigem || clientePagadorAsDestino) {
          clientePagadorFront = `${data.razaoSocialClientePagador} -
          ${formatarCnpjCpfIMask(data.cnpjClientePagador)} -
          ${customUpperCase(
            clientePagadorAsOrigem?.cidade || clientePagadorAsDestino?.cidade
          )}
          (${clientePagadorAsOrigem?.estado ||
            clientePagadorAsDestino?.estado}) -
          ${clientePagadorAsOrigem?.bairro || clientePagadorAsDestino?.bairro}`;
        }

        const dadosDemanda = {
          cnpjPagador:
            clientePagadorFront ||
            `${data.razaoSocialClientePagador} -
          ${formatarCnpjCpfIMask(data.cnpjClientePagador)}`,
          produto: data.idProduto,
          especie: data.idEspecie,
          numPedidoCliente: data.numPedidoCliente,
          observacoes: data.observacao,
        };

        setClienteEnderecoRemetente(data.enderecoOrigem);
        setClienteEnderecoDestinatario(data.enderecoDestino);
        setClienteExpedidor(data.enderecoExpedidor);
        setClienteRecebedor(data.enderecoRecebedor);
        setLotes(data.lotes);

        if (data?.contatos) {
          setContatosAction(data.contatos);
        }

        for (let index = 0; index < data.lotes.length; index++) {
          if (data.lotes[index].contrato != null) {
            setHasContrato(data.lotes[index].contrato != null);
            continue;
          }

          if (data.lotes[index].hasMotoristaLote) {
            setHasMotorista(data.lotes[index].hasMotoristaLote);
            continue;
          }
        }

        form.setFieldsValue(dadosDemanda);

        setDemanda(data);

        const customEventId = geradorIdUnico();
        setEventId(customEventId);
        gTagEntrada(
          'Redirect - Editando Demanda',
          'Demanda',
          'Editando demanda',
          customEventId
        );
        if (currentStep === 0) {
          gTagSaida(
            `Passo - ${steps[currentStep].title}`,
            'Demanda',
            `Entrou no ${steps[currentStep].title}`,
            customEventId
          );
        }

        if (location.state?.step) {
          const { step } = location.state;

          redirecionaStep(step);

          gTagEntrada(
            `Passo - ${steps[step].title}`,
            'Demanda',
            `Estrou no ${steps[step].title}`,
            customEventId
          );
        }
      } catch (error) {
        notification.error({
          message: 'Ops, não foi possível recuperar a demanda',
          description:
            'Por favor, entre em contato com nosso suporte caso o problema persistir.',
        });
      } finally {
        if (!location.state?.step) {
          setLoading(false);
        }
      }
    }
    onInit();
  }, [form, idDemanda]);

  return (
    <>
      <GlobalStyle />
      <SpinAllSize size="large" spinning={loading}>
        <Form
          form={form}
          layout="vertical"
          onFieldsChange={validateFormDebounced}
        >
          <Row>
            <Col span={18} offset={3}>
              <Steps current={currentStep} size="small" className="customSteps">
                {steps.map(item => (
                  <Step key={item.title} title={item.title} />
                ))}
              </Steps>
            </Col>
          </Row>

          <Row>
            <Col span={24}>
              <AlertAviso
                messageErrors={alertMessageErrors}
                setAlertMessageErrors={setAlertMessageErrors}
              />
            </Col>
          </Row>

          <StepContent>
            {steps[currentStep].content}
            <Footer gutter={12} justify="end">
              <VoltarButton
                className="margin-sides"
                onClick={previousStep}
                disabled={loading}
              >
                Voltar
              </VoltarButton>
              {currentStep === steps.length - 1 && (
                <Button
                  type="primary"
                  htmlType="submit"
                  disabled={disableNext}
                  loading={loading}
                  onClick={handleSubmit}
                >
                  Salvar
                </Button>
              )}
              {currentStep < steps.length - 1 && (
                <Button
                  type="primary"
                  onClick={nextStep}
                  disabled={disableNext}
                >
                  Continuar
                </Button>
              )}
            </Footer>
          </StepContent>
        </Form>
      </SpinAllSize>
    </>
  );
};

export default CadastroDemanda;
